import {useTranslation} from '@aboutyou/i18n';
import React, {FC} from 'react';
import {SizeTabsWithClusters} from '../../FilterContent/Size/SizeTabsWithClusters';
import {getActiveSizeFiltersCount} from '../../FilterContent/Size/helpers';
import {SizeRunCluster, SizeTab} from '../../FilterContent/Size/types';
import {FilterDropdown} from '../FilterDropdown';

interface Props {
  activeFilters: Map<string, Array<string> | undefined>;
  content?: {
    clusters?: Array<SizeRunCluster>;
    tabs?: SizeTab[];
  };
  onTabsReset: (slug: string) => void;
  onSizeClick: (slug: string, sizeId: string) => void;
  onTabClick: (slug: string, sizeId: string) => void;
  onFilterReset: () => void;
  onOpen?: () => void;
  onClose?: () => void;
}

export const FilterDropdownSizeGrouped: FC<Props> = ({
  activeFilters,
  content,
  onTabsReset,
  onSizeClick,
  onTabClick,
  onFilterReset,
  onClose,
  onOpen,
}) => {
  const {t} = useTranslation();

  const clusters = content?.clusters;
  const tabs = content?.tabs;

  return (
    <FilterDropdown
      dataTestId="filterDropdownSizeGrouped"
      activeCount={getActiveSizeFiltersCount({activeFilters, clusters, tabs})}
      label={t('Size')}
      onReset={onFilterReset}
      onClose={onClose}
      onOpen={onOpen}
      filterContent={
        <SizeTabsWithClusters
          activeFilters={activeFilters}
          content={content}
          onTabsReset={onTabsReset}
          onSizeClick={onSizeClick}
          onTabClick={onTabClick}
        />
      }
      padContent={false}
      showScrollFade
    />
  );
};
